import type {
	Floor,
	ShadowCreateFloorRequest,
	ShadowUpdateFloorRequest,
} from "@sitescene/types";

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

/**
 * Shadow Realm floors API (org via `X-Shadow-Org` on the client).
 */
export const floorsApi = {
	createFloor: async (body: ShadowCreateFloorRequest): Promise<Floor> => {
		const response = await apiClient.post<Floor>(
			ENDPOINTS.shadow.floors.create,
			body,
		);
		return response.data;
	},

	updateFloor: async (
		floorId: string,
		body: ShadowUpdateFloorRequest,
	): Promise<Floor> => {
		const response = await apiClient.patch<Floor>(
			ENDPOINTS.shadow.floors.update(floorId),
			body,
		);
		return response.data;
	},
};
